import { RouteType } from '@/Routes';
import { lazy } from 'react';

const IndexGfProject = lazy(() => import('@/pages/projects'));
const GfProjectShow = lazy(() => import('@/pages/projects/[id]'));
const ProjectHistory = lazy(() => import('@/pages/projects/histories'));
const ProjectHistoryYM = lazy(
  () => import('@/pages/projects/histories/[year]/[month]')
);

const ServerProject: RouteType[] = [
  { path: '/projects', component: IndexGfProject, title: '取引リスト' },
  { path: '/projects/histories', component: ProjectHistory, title: '取引履歴' },
  { path: '/projects/histories/:year/:month', component: ProjectHistoryYM },
  { path: '/projects/:id([0-9]+)', component: GfProjectShow },
];

export default ServerProject;
